import {
  NOT,
  YES
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import Definition, {
  ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS,
  DEFINITION_CATEGORY__ATS_TYPE,
  ID__ATS_TYPE__ASHBY_API,
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION,
  ID__ATS_TYPE__LEVER_API,
  ID__ATS_TYPE__NONE
} from '../../../lib/Definition';
import {
  Fun
} from '../../../lib/Function.lib';
import useState from '../../../lib/hooks/useState.hook';
import {
  Obj
} from '../../../lib/Object.lib';
import fetchAtsContext from '../../../lib/services/ATS/fetchAtsContext.async';
import getAtsContextProperty from '../../../lib/services/ATS/getAtsContextProperty.fun';
import getAtsContextUpdated from '../../../lib/services/ATS/getAtsContextUpdated.fun';
import {
  Str
} from '../../../lib/String.lib';
import formatURL from '../../../lib/tools/formatURL';
import Box from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import Fieldset from '../../Layout/Wrappers/Fieldset';
import Menu from '../../Layout/Wrappers/Menu';
import Once from '../../Layout/Wrappers/Once';
import TextField from '../../Layout/Wrappers/TextField';
import {
  Label
} from '../../Layout/Wrappers/Typography';
import {
  getControllerButtonOpenEmployerSettings
} from './ButtonOpenEmployerSettings';
import SubSectionAtsSettingsAshbyAdmin from './SubsectionAtsSettingsAshbyAdmin';
import SubSectionAtsSettingsAshbyEmployer from './SubsectionAtsSettingsAshbyEmployer';
import SubSectionAtsSettingsGreenhouse from './SubSectionAtsSettingsGreenhouse';
import SubSectionAtsSettingsLeverApi from './SubSectionAtsSettingsLeverApi';

export default function SectionAtsSettings({
  acl = true,
  employerId = '',
  onChange = Fun,
  innerWrapperProps = {},
  ...props
}) {

  const [employer, updateEmployer] = useState();

  acl = (
    acl &&
    (
      Core.isEmployer() ||
      Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS })
    )
  );

  if (NOT(acl)) { return null; }

  const LIST__TAGS__ATS_TYPES = (
    Definition.get(
      DEFINITION_CATEGORY__ATS_TYPE
    ).sort(
      (a, b) => +a.id === ID__ATS_TYPE__NONE ? -1 : Str(a.label).localeCompare(
        Str(b.label)
      )
    )
  );

  const ID__ATS_TYPE = parseInt(employer.atsTypeId);

  const VALUE__ATS__URL = getAtsContextProperty({
    entity: employer,
    atsTypeId: ID__ATS_TYPE,
    property: 'manualSubmissionUrl'
  });

  const YES__SELECTED_ATS = (
    YES(ID__ATS_TYPE) &&
    (ID__ATS_TYPE !== ID__ATS_TYPE__NONE)
  );

  const YES__ATS__ASHBY = (
    ID__ATS_TYPE === ID__ATS_TYPE__ASHBY_API
  );

  const YES__ATS__GH = [
    ID__ATS_TYPE__GH_HARVEST,
    ID__ATS_TYPE__GH_INGESTION
  ].includes(ID__ATS_TYPE);

  const YES__ATS__LEVER_API = (
    ID__ATS_TYPE === ID__ATS_TYPE__LEVER_API
  );

  const fetchEmployer = async () => {
    onChangeEmployer(Obj(
      await fetchAtsContext({
        entityId: employerId
      })
    ));
  }

  const onChangeEmployer = async (update) => {
    await updateEmployer(update);
    onChange(update);
  }

  function onChangeSelectAtsType(atsTypeId) {
    onChangeEmployer({ atsTypeId });
    try {
      const CONTROLLER__GEAR_ACTION = getControllerButtonOpenEmployerSettings();
      CONTROLLER__GEAR_ACTION.updateState({
        employer: {
          ...Obj(CONTROLLER__GEAR_ACTION.state?.employer),
          atsTypeId
        }
      });
    }
    catch { }
  }

  function onChangeTextField(field) {
    return async (event, value) => {
      await onChangeEmployer(
        getAtsContextUpdated({
          entity: employer,
          atsTypeId: ID__ATS_TYPE,
          update: {
            [field]: value
          }
        })
      );
    }
  }

  return (

    <Box column className="rounded-sm outlined p-05" {...props}>

      <Box column className='bg-main rounded-sm' {...innerWrapperProps}>

        <Once
          acl={employerId}
          promise={fetchEmployer}
        />

        <Box row
          acl={Core.isAdmin()}
          className='flex-align-left-top mt-2'
        >

          <Fieldset
            title={
              <Label className='tt-none'>
                What ATS is the company using?
              </Label>
            }
            subtitle='Choose one from the dropdown'
          >
            <Menu dropdown avoidNullOption
              value={ID__ATS_TYPE}
              onChange={onChangeSelectAtsType}
              options={LIST__TAGS__ATS_TYPES}
            />
          </Fieldset>

          {YES__SELECTED_ATS && (
            <Fieldset
              title={
                <Label className='tt-none'>
                  ATS URL
                </Label>
              }
              subtitle='URL to open for ATS submission if Auth is unavailable.'
              actionBar={
                Core.isAdmin() && (
                  <Button small flat
                    onClick={event => Core.openPopUp(Core.getPath(`admin/ats/mapping/${employerId}`), 1200)}
                    className='tt-unset c-black-medium'
                    startIcon={
                      <i className='material-icons c-inherit'>launch</i>
                    }
                    style={{ height: 20 }}
                  >
                    Edit ATS mapping rules
                  </Button>
                )
              }
            >
              <TextField
                value={VALUE__ATS__URL}
                onChange={onChangeTextField('manualSubmissionUrl')}
                onBlur={(event) => onChangeEmployer(
                  getAtsContextUpdated({
                    entity: employer,
                    atsTypeId: ID__ATS_TYPE,
                    update: {
                      manualSubmissionUrl: formatURL(event.target.value)
                    }
                  })
                )}
                style={{ marginBottom: '0.75rem' }}
                fullWidth
              />
            </Fieldset>
          )}

        </Box>

        <SubSectionAtsSettingsGreenhouse
          acl={YES__ATS__GH && employer.id}
          entity={employer}
          onChange={onChangeEmployer}
        />

        <SubSectionAtsSettingsLeverApi
          acl={YES__ATS__LEVER_API && employer.id}
          entity={employer}
          onChange={onChangeEmployer}
        />

        {Core.isAdmin()
          ? (
            <SubSectionAtsSettingsAshbyAdmin
              acl={YES__ATS__ASHBY && employer.id}
              entity={employer}
              onChange={onChangeEmployer}
            />
          ) : (
            <SubSectionAtsSettingsAshbyEmployer
              acl={YES__ATS__ASHBY && employer.id}
              entity={employer}
              onChange={onChangeEmployer}
            />
          )
        }

      </Box>

    </Box>

  );
}
